var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7BCB45",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 328 328",
    style: {
      enableBackground: "new 0 0 328 328"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173,258h-19c-8.284,0-15,6.716-15,15v40c0,8.284,6.716,15,15,15h19c8.284,0,15-6.716,15-15v-40 C188,264.716,181.284,258,173,258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,0h-19c-8.284,0-15,6.716-15,15v40c0,8.284,6.716,15,15,15h19c8.284,0,15-6.716,15-15V15C188,6.716,181.284,0,173,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.834,223.536c-5.834-5.834-15.38-5.834-21.213,0l-28.457,28.457c-5.834,5.834-5.834,15.38,0,21.213l13.63,13.63 c5.834,5.834,15.38,5.834,21.213,0l28.457-28.457c5.834-5.834,5.834-15.38,0-21.213L90.834,223.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.166,104.464c5.834,5.834,15.38,5.834,21.213,0l28.457-28.457c5.834-5.834,5.834-15.38,0-21.213l-13.63-13.63 c-5.834-5.834-15.38-5.834-21.213,0l-28.457,28.457c-5.834,5.834-5.834,15.38,0,21.213L237.166,104.464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,173v-19c0-8.284-6.716-15-15-15H15c-8.284,0-15,6.716-15,15v19c0,8.284,6.716,15,15,15h40 C63.284,188,70,181.284,70,173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,139h-40c-8.284,0-15,6.716-15,15v19c0,8.284,6.716,15,15,15h40c8.284,0,15-6.716,15-15v-19 C328,145.716,321.284,139,313,139z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.007,41.164c-5.834-5.834-15.38-5.834-21.213,0l-13.63,13.63c-5.834,5.834-5.834,15.38,0,21.213l28.457,28.457 c5.834,5.834,15.38,5.834,21.213,0l13.63-13.63c5.834-5.834,5.834-15.38,0-21.213L76.007,41.164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.379,223.536c-5.834-5.834-15.38-5.834-21.213,0l-13.63,13.63c-5.834,5.834-5.834,15.38,0,21.213l28.457,28.457 c5.834,5.834,15.38,5.834,21.213,0l13.63-13.63c5.834-5.834,5.834-15.38,0-21.213L258.379,223.536z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingGreen);
export default __webpack_public_path__ + "static/media/loadingGreen.5f08665b840c9ee639ad795869f1462a.svg";
export { ForwardRef as ReactComponent };